import { gql } from 'react-apollo';

import {
  BOOKING_PAYMENT_START,
  BOOKING_PAYMENT_GUEST_ACCOUNT_CREATED,
  BOOKING_PAYMENT_UPDATE_BOOKDETAILS,
  BOOKING_PAYMENT_SUCCESS,
  BOOKING_PAYMENT_ERROR,
} from '../../constants';

// Redux
import { setRuntimeVariable } from '../runtime';
import { loadAccount } from '../account';

// Helper
import fetch from '../../core/fetch';
import { convert } from '../../helpers/currencyConvertion';
import trackBooking from '../../helpers/trackBooking';

import { toastr } from 'react-redux-toastr';
import pMath from '../../helpers/pMath';

export function makePayment({
  listId,
  title,
  hostId,
  guestId,
  checkIn,
  checkOut,
  guests,
  freeTrialDaysCount,
  message,
  basePrice,
  cleaningPrice,
  currency,
  discount,
  discountType,
  guestServiceFee,
  hostServiceFee,
  total,
  authorisationAmount,
  bookingType,
  paymentCurrency,
  paymentType,
  specialPricing,
  isSpecialPriceAssigned,
  isSpecialPriceAverage,
  isHotDesking,
  isOpenOnWeekends,
  dayDifference,
  taxRate,
  taxAmount,
  checkInStart,
  checkInEnd,
  hostServiceFeeType,
  hostServiceFeeValue,
  name,
  guestEmail,
  paymentMethodId,
  isExpressCheckout,
  monthlyPass,
  monthlyPassAuthDeposit,
  monthlyPassSubscriptionStage,
  paymentIntentId
}) {

  return async (dispatch, getState, { client }) => {

    dispatch({
      type: BOOKING_PAYMENT_START,
      payload: {
        paymentLoading: true
      }
    });

    try {
      const mutation = gql`
        mutation createReservation(
          $listId: Int!, 
          $hostId: String!,
          $guestId: String!,
          $isSubscription: Boolean!,
          $checkIn: String!,
          $checkOut: String,
          $guests: Int!,
          $freeTrialDays: Int!,
          $message: String,
          $basePrice: Float!,
          $cleaningPrice: Float,
          $currency: String!,
          $discount: Float,
          $discountType: String,
          $guestServiceFee: Float,
          $hostServiceFee: Float,
          $total: Float!,
          $bookingType: String,
          $paymentType: Int!,
          $cancellationPolicy: Int!,
          $specialPricing: String,
          $isSpecialPriceAssigned: Boolean,
          $isSpecialPriceAverage: Float,
          $isHotDesking: Boolean,
          $isOpenOnWeekends: Boolean,
          $dayDifference: Float,
          $taxRate: Float,
          $taxAmount: Float,
          $checkInStart: String,
          $checkInEnd: String,
          $hostServiceFeeType: String,
          $hostServiceFeeValue: Float,
          $name: String,
          $email: String,
        ){
            createReservation(
              listId: $listId,
              hostId: $hostId,
              guestId: $guestId,
              isSubscription: $isSubscription,
              checkIn: $checkIn,
              checkOut: $checkOut,
              guests: $guests,
              freeTrialDays: $freeTrialDays,
              message: $message,
              basePrice: $basePrice,
              cleaningPrice: $cleaningPrice,
              currency: $currency,
              discount: $discount,
              discountType: $discountType,
              guestServiceFee: $guestServiceFee,
              hostServiceFee: $hostServiceFee,
              total: $total,
              bookingType: $bookingType,
              paymentType: $paymentType,
              cancellationPolicy: $cancellationPolicy,
              specialPricing: $specialPricing,
              isSpecialPriceAssigned: $isSpecialPriceAssigned,
              isSpecialPriceAverage: $isSpecialPriceAverage,
              isHotDesking: $isHotDesking,
              isOpenOnWeekends: $isOpenOnWeekends,
              dayDifference: $dayDifference,
              taxRate: $taxRate,
              taxAmount: $taxAmount,
              checkInStart: $checkInStart,
              checkInEnd: $checkInEnd,
              hostServiceFeeType: $hostServiceFeeType,
              hostServiceFeeValue: $hostServiceFeeValue,
              name: $name,
              email: $email,
            ) {
                id
                listId,
                hostId,
                guestId,
                isSubscription,
                checkIn,
                checkOut,
                guests,
                freeTrialDays,
                message,
                basePrice,
                cleaningPrice,
                currency,
                discount,
                discountType,
                guestServiceFee,
                hostServiceFee,
                total,
                confirmationCode,
                createdAt
                status
                paymentMethodId,
                cancellationPolicy,
                isSpecialPriceAverage,
                isHotDesking,
                isOpenOnWeekends,
                dayDifference,
                taxRate,
                taxAmount,
                checkInStart,
                checkInEnd,
                hostServiceFeeType,
                hostServiceFeeValue,
                name,
                email
            }
        }
      `;

      let preApprove = getState().book.bookDetails.preApprove;
      let bookingTypeData;
      if (preApprove === true) {
        bookingTypeData = 'instant';
      } else {
        bookingTypeData = bookingType;
      }

      let cancellationPolicy = getState().book.data.listingData.cancellation.id;

      const { data } = await client.mutate({
        mutation,
        variables: {
          listId,
          hostId,
          guestId,
          isSubscription: Boolean(monthlyPass),
          checkIn,
          checkOut,
          guests,
          freeTrialDays: freeTrialDaysCount,
          message,
          basePrice,
          cleaningPrice,
          currency,
          discount,
          discountType,
          guestServiceFee,
          hostServiceFee,
          total,
          bookingType: bookingTypeData,
          paymentType,
          cancellationPolicy,
          specialPricing,
          isSpecialPriceAssigned,
          isSpecialPriceAverage,
          isHotDesking,
          isOpenOnWeekends,
          dayDifference,
          taxRate,
          taxAmount,
          checkInStart,
          checkInEnd,
          hostServiceFeeType,
          hostServiceFeeValue,
          name,
          email: guestEmail
        }
      })

      if (data && data.createReservation) {
        if( data.createReservation.error ) {
          dispatch({
            type: BOOKING_PAYMENT_ERROR,
            payload: {
              status: data.createReservation.status,
              error: data.createReservation.error,
              errorType: data.createReservation.errorType,
              paymentLoading: false
            }
          });
          return {
            status: 500
          };
        }
        
        if( !guestId ) {
          guestId = data.createReservation.guestId;
          dispatch(loadAccount(false, ''));
          dispatch(setRuntimeVariable({
            name: 'isAuthenticated',
            value: true,
          }));
          dispatch({
            type: BOOKING_PAYMENT_GUEST_ACCOUNT_CREATED,
            payload: {
              guestAccountCreated: true
            }
          });
        }

        let reservationId = data.createReservation.id;
        let amount = total;
        let rates = getState().currency.rates;
        let currentCurrency = (getState().currency.to) ? getState().currency.to : getState().currency.base;
        let baseCurrency = getState().currency.base;
        let convertedAmount = convert(baseCurrency, rates, amount, currency, currentCurrency);
        let convertedAuthorisationAmount = convert(baseCurrency, rates, authorisationAmount, currency, currentCurrency);
        let convertedStripeAmount = Math.round(convertedAmount*100);
        let convertedStripeAuthorisationAmount = Math.round(convertedAuthorisationAmount*100);
        
        let status, errorMessage, paymentIntentSecret;

        dispatch({
          type: BOOKING_PAYMENT_UPDATE_BOOKDETAILS,
          payload: {
            reservationId,
            currency,
            convertedAmount
          }
        });

        if( monthlyPass && !monthlyPassAuthDeposit ) { //Do not redirect - confirmation in PaymentForm
          return {
            status: 200,
            reservationId,
            convertedAmount
          };
        }
        else if( isExpressCheckout ) {
          const updateRes = await fetch('/stripe-update-express-intent', {
            method: 'post',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              reservationId,
              paymentIntentId,
              convertedAmount: convertedStripeAmount
            }),
            credentials: 'include'
          });
          ({ status, errorMessage } = await updateRes.json());
        }
        else {
          const resp = await fetch('/stripe-reservation', {
            method: 'post',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              reservationId,
              paymentMethodId,
              convertedAmount: monthlyPassAuthDeposit ? convertedStripeAuthorisationAmount : convertedStripeAmount,
              bookDetails: getState().book.bookDetails,
              monthlyPass
            }),
            credentials: 'include'
          });
          ({ status, errorMessage, paymentIntentId, paymentIntentSecret } = await resp.json());
        }

        if (status === 200) {
          if( paymentIntentId ) {
            dispatch({
              type: BOOKING_PAYMENT_UPDATE_BOOKDETAILS,
              payload: {
                paymentIntentId,
                paymentIntentSecret
              }
            });
          }

          if( monthlyPassAuthDeposit ) {
            await dispatch({
              type: BOOKING_PAYMENT_SUCCESS,
              payload: { paymentLoading: false }
            });
            
            return {
              status,
              paymentIntentId,
              paymentIntentSecret,
              reservationId,
              convertedAmount
            };
          }

          await dispatch({
            type: BOOKING_PAYMENT_SUCCESS,
            payload: { paymentLoading: true }
          });

          trackBooking({
            currency: paymentCurrency,
            value: convertedAmount,
            reservationId,
            listingId: listId,
            listingTitle: title
          });
          
          window.location = '/users/trips/itinerary/' + reservationId;

          return {
            status,
            paymentIntentId,
            paymentIntentSecret,
            reservationId,
            convertedAmount
          };
        } else if( status === 401 ) {
          return {
            status,
            paymentIntentId,
            paymentIntentSecret,
            reservationId,
            convertedAmount
          };
        }
        else {
          if( errorMessage ) {
            toastr.error('Error', errorMessage);
          }
          await dispatch({
            type: BOOKING_PAYMENT_ERROR,
            payload: { paymentLoading: false }
          });
          return {
            status,
            paymentIntentId,
            paymentIntentSecret,
            reservationId,
            convertedAmount
          }
        }
      }
    } catch (error) {
      dispatch({
        type: BOOKING_PAYMENT_ERROR,
        payload: {
          error,
          paymentLoading: false
        }
      });
      return {
        status: 500
      };
    }

    return true;
  };
}




// WEBPACK FOOTER //
// src/actions/booking/makePayment.js